import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMCustomer } from "../graphql/mutations";
import {
  UpdateLLMCustomerInput,
  UpdateLLMCustomerMutation,
} from "../API";

export async function updateLLMCustomerAfterEdit(
  values: UpdateLLMCustomerInput
): Promise<GraphQLResult<UpdateLLMCustomerMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMCustomer, {
      input: {
        id: values.id,
        name: values.name,
        status: values.status,
        tokensRemaining: values.tokensRemaining,
        projectId: values.projectId,
        loadSheddingTier: values.loadSheddingTier,
        dataResidency: values.dataResidency,
        enterpriseUser: values.enterpriseUser ?? false,
        tokenReplenishmentAmount: values.tokenReplenishmentAmount ? values.tokenReplenishmentAmount : 0,
        tokenReplenishmentPeriod: values.tokenReplenishmentPeriod ? values.tokenReplenishmentPeriod : undefined
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMCustomerMutation>>;
}
